<div class="onboarding-container">
  <mat-card class="onboarding-card">
    <mat-card-header class="onboarding-header">
      <mat-card-title class="onboarding-title">
        <mat-icon class="title-icon">rocket_launch</mat-icon>
        Eerste Inlog - Inrichting Omgeving
      </mat-card-title>
    </mat-card-header>

    <mat-card-content class="onboarding-content">
      <mat-stepper linear #stepper>
        <!-- Step 1: Intro -->
        <mat-step label="Inleiding">
          <div class="step-content">
            <h3 class="step-heading">Welkom bij RobotCtrl</h3>
            <p class="step-description">
              Uw RobotCtrl-omgeving is aangemaakt. Voordat u aan de slag gaat, vragen wij u om de inrichting van uw omgeving eenmalig af te ronden.
            </p>
            <p class="step-description">
              Doorloop hiervoor de onderstaande stappen. Zodra de inrichting is voltooid, is uw omgeving volledig beschikbaar.
            </p>
            <p class="step-note">
              Deze inrichting doorloopt u eenmalig, bij de eerste inlog op uw omgeving.
            </p>
            <div class="flex justify-end gap-2 mt-4">
              <button mat-flat-button matStepperNext>Volgende</button>
            </div>
          </div>
        </mat-step>

        <!-- Step 2: Invoice Data -->
        <mat-step [stepControl]="billingForm" label="Facturatiegegevens">
          <form [formGroup]="billingForm" class="step-content">
            <h3 class="step-heading">Vul uw facturatiegegevens in</h3>
            <p class="step-description">
              Deze gegevens worden gebruikt voor de correcte verwerking van facturen en inkooporders.
            </p>
            <p class="step-note">
              Eenmaal ingevuld kunnen deze gegevens achteraf niet meer leeggemaakt worden.
            </p>

            <mat-form-field class="full-width">
              <mat-label>Inkoopnummer / Referentie</mat-label>
              <input
                matInput
                formControlName="purchaseNumber"
                placeholder="bijv. PO-2026-001"
                required
              />
              @if (billingForm.controls['purchaseNumber'].hasError('required')) {
                <mat-error>Inkoopnummer is verplicht</mat-error>
              }
            </mat-form-field>

            <mat-form-field class="full-width">
              <mat-label>Factuur e-mailadres</mat-label>
              <input
                matInput
                type="email"
                formControlName="invoiceEmail"
                placeholder="bijv. facturatie@organisatie.nl"
                required
              />
              @if (billingForm.controls['invoiceEmail'].hasError('required')) {
                <mat-error>Factuur e-mailadres is verplicht</mat-error>
              }
              @if (billingForm.controls['invoiceEmail'].hasError('email')) {
                <mat-error>Voer een geldig e-mailadres in</mat-error>
              }
            </mat-form-field>

            <div class="flex justify-end gap-2 mt-4">
              <button mat-button matStepperPrevious>Terug</button>
              <button mat-flat-button matStepperNext [disabled]="billingForm.invalid">
                Volgende
              </button>
            </div>
          </form>
        </mat-step>

        <!-- Step 3: Confirmation -->
        <mat-step label="Bevestigen">
          <div class="step-content">
            <h3 class="step-heading">Controleer uw gegevens</h3>
            <p class="step-description">
              Controleer onderstaande gegevens voor het afronden van de inrichting:
            </p>

            <div class="summary-box">
              <div class="summary-item">
                <span class="summary-label">Inkoopnummer:</span>
                <span class="summary-value">{{ billingForm.value.purchaseNumber || '-' }}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">Factuur e-mailadres:</span>
                <span class="summary-value">{{ billingForm.value.invoiceEmail || '-' }}</span>
              </div>
            </div>

            <div class="flex justify-end gap-2 mt-4">
              <button mat-button matStepperPrevious [disabled]="isSubmitting()">
                Terug
              </button>
              <button
                mat-flat-button
                color="primary"
                [disabled]="isSubmitting() || billingForm.invalid"
                (click)="submitOnboarding()"
              >
                @if (isSubmitting()) {
                  Bezig met opslaan...
                } @else {
                  Inrichting voltooien
                }
              </button>
            </div>
          </div>
        </mat-step>
      </mat-stepper>
    </mat-card-content>
  </mat-card>
</div>
